import React from 'react';
import { Link } from 'react-router-dom';

// Aday verisi - CSV dosyasından alınan veriler
const candidates = [
  {
    id: 1,
    name: 'Mehmet İsmet Beşik',
    position: 'Yönetim Kurulu Asıl',
    department: 'Siyaset Bilimi ve Kamu Yönetimi 1981',
    departmentCode: 'ADM',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/ismet-be%C5%9Fik-62754934/',
    image: '/images/candidates/IsmetBesik.jpg',
  },
  {
    id: 2,
    name: 'Orhan Tola',
    position: 'Yönetim Kurulu Asıl',
    department: 'Makina Mühendisliği 1986',
    departmentCode: 'ME',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/orhan-tola-0621273a/',
    image: '/images/candidates/OrhanTola.jpg',
  },
  {
    id: 3,
    name: 'Bektaş Özkan',
    position: 'Yönetim Kurulu Asıl',
    department: 'Fizik 1992',
    departmentCode: 'PHYS',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/bektasozkan/',
    image: '/images/candidates/bektasozkan.jpg',
  },
  {
    id: 4,
    name: 'Selçuk Koçum',
    position: 'Yönetim Kurulu Asıl',
    department: 'Metalurji Mühendisliği 1992',
    departmentCode: 'METE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/selcuk-kocum-144a6b/',
    image: '/images/candidates/SelcukKocum.jpg',
  },
  {
    id: 5,
    name: 'Selma Ergin',
    position: 'Yönetim Kurulu Asıl',
    department: 'Endüstri Mühendisliği 1986',
    departmentCode: 'IE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/selma-ergin-b5a8868/',
    image: '/images/candidates/SelmaErgin.jpg',
  },
  {
    id: 6,
    name: 'Tülin Cevizci',
    position: 'Yönetim Kurulu Asıl',
    department: 'Şehir ve Bölge Planlama 1990',
    departmentCode: 'CRP',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/tulin-cevizci-55128919/',
    image: '/images/candidates/TulinCevizcioglu.jpg',
  },
  {
    id: 7,
    name: 'Ali Öztüfekçi',
    position: 'Yönetim Kurulu Asıl',
    department: 'Jeoloji Mühendisliği 1998',
    departmentCode: 'GEOE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/ali-oztufekci-76177645/',
    image: '/images/candidates/AliOztufekci.jpg',
  },
  {
    id: 8,
    name: 'Selçuk Saraç',
    position: 'Yönetim Kurulu Yedek',
    department: 'Makina Mühendisliği 1994',
    departmentCode: 'ME',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/selcuk-sarac-037a6312/',
    image: '/images/candidates/SelcukSarac.jpg',
  },
  {
    id: 9,
    name: 'Muzaffer Bayazıtoğlu',
    position: 'Yönetim Kurulu Yedek',
    department: 'Jeoloji Mühendisliği 1994',
    departmentCode: 'GEOE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/muzafferbayazitoglu/',
    image: '/images/candidates/MuzafferBayazit.jpg',
  },
  {
    id: 10,
    name: 'Damla Kalan Dilekcan',
    position: 'Yönetim Kurulu Yedek',
    department: 'Kimya Mühendisliği 1994',
    departmentCode: 'CHE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/damla-kalan-dilekcan-027442/',
    image: '/images/candidates/DamlaKalanDilekcan.jpg',
  },
  {
    id: 11,
    name: 'Sedat Taşkeser',
    position: 'Yönetim Kurulu Yedek',
    department: 'Endüstri Mühendisliği 1987',
    departmentCode: 'IE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/sedat-ta%C5%9Fkeser-2212752/',
    image: '/images/candidates/SedatTaskeser.jpg',
  },
  {
    id: 12,
    name: 'Melike Cavcar',
    position: 'Yönetim Kurulu Yedek',
    department: 'Metalurji Mühendisliği 1991',
    departmentCode: 'METE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/melikecavcar/',
    image: '/images/candidates/MelikeCavcar.jpg',
  },
  {
    id: 13,
    name: 'Murat Tuğasaygı',
    position: 'Yönetim Kurulu Yedek',
    department: 'Elektrik Elekronik Mühendisliği 1989',
    departmentCode: 'EEE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/murat-tugasaygi-4983425/',
    image: '/images/candidates/MuratTugasaygi.jpg',
  },
  {
    id: 14,
    name: 'Kadri Özbey',
    position: 'Yönetim Kurulu Yedek',
    department: 'Endüstri Mühendisliği 1989',
    departmentCode: 'IE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/kadri-%C3%B6zbey-31977913/',
    image: '/images/candidates/KadriOzbey.jpg',
  },
  {
    id: 15,
    name: 'Zeynep Berberoğlu',
    position: 'Disiplin Asıl',
    department: 'Siyaset Bilimi ve Kamu Yönetimi 1983',
    departmentCode: 'ADM',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/zeynep-berberoglu-0b90a81/',
    image: '/images/candidates/ZeynepBerberoglu.jpg',
  },
  {
    id: 16,
    name: 'Türkü Karan',
    position: 'Disiplin Asıl',
    department: 'İşletme 1991',
    departmentCode: 'MAN',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/turku-karan-457975b/',
    image: '/images/candidates/turkukaran.jpg',
  },
  {
    id: 17,
    name: 'Şule Onur',
    position: 'Disiplin Asıl',
    department: 'Şehir ve Bölge Planlama 1990',
    departmentCode: 'CRP',
    bio: '',
    linkedin: '',
    image: '/images/candidates/SuleOnur.jpg',
  },
  {
    id: 18,
    name: 'Yasemin Civelekoğlu',
    position: 'Disiplin Yedek',
    department: 'Kimya Mühendisliği 1978',
    departmentCode: 'CHE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/yasemin-civelekoglu-269a7b12/',
    image: '/images/candidates/YaseminCivelekoglu.jpg',
  },
  {
    id: 19,
    name: 'Ali Haydar Elveren',
    position: 'Disiplin Yedek',
    department: 'İktisat 1990',
    departmentCode: 'ECON',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/ali-haydar-elveren-2b76a516/',
    image: '/images/candidates/AliHaydarElveren.jpg',
  },
  {
    id: 20,
    name: 'Serpil Uzun',
    position: 'Disiplin Yedek',
    department: 'İktisat 1994',
    departmentCode: 'ECON',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/serpil-uzun-12447aa/',
    image: '/images/candidates/SerpilUzun.jpg',
  },
  {
    id: 22,
    name: 'Oğuzhan Aygün',
    position: 'Denetleme Asıl',
    department: 'Endüstri Mühendisliği 1986',
    departmentCode: 'IE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/oguzhan-aygun-77204315/',
    image: '/images/candidates/oguzhanaygun.jpg',
  },
  {
    id: 23,
    name: 'Özden Duymaz',
    position: 'Denetleme Asıl',
    department: 'Maden Mühendisliği 2010',
    departmentCode: 'MINE',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/ozden-duymaz-60499158/',
    image: '/images/candidates/OzdenDuymaz.jpg',
  },
  {
    id: 24,
    name: 'M. Ali Acartürk',
    position: 'Denetleme Yedek',
    department: 'İşletme 1978',
    departmentCode: 'MAN',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/mehmet-ali-acart%C3%BCrk-09046a1a3/',
    image: '/images/candidates/MAliAcarturk.jpg',
  },
  {
    id: 25,
    name: 'Barçın Yinanç',
    position: 'Denetleme Yedek',
    department: 'Uluslararası İlişkiler 1991',
    departmentCode: 'IR',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/bar%C3%A7%C4%B1n-yinan%C3%A7-57b90356/',
    image: '/images/candidates/BarcinYinanc.jpg',
  },
  {
    id: 26,
    name: 'Nebil Göğüş',
    position: 'Denetleme Yedek',
    department: 'İşletme 1979',
    departmentCode: 'MAN',
    bio: '',
    linkedin: 'https://www.linkedin.com/in/nebil-gogus-34b83253/',
    image: '/images/candidates/NebilGogus.jpg',
  },
];

// Adayları pozisyonlarına göre gruplandırma
const groupedCandidates = {
  'Yönetim Kurulu Asıl': candidates.filter(c => c.position === 'Yönetim Kurulu Asıl'),
  'Yönetim Kurulu Yedek': candidates.filter(c => c.position === 'Yönetim Kurulu Yedek'),
  'Disiplin Asıl': candidates.filter(c => c.position === 'Disiplin Asıl'),
  'Disiplin Yedek': candidates.filter(c => c.position === 'Disiplin Yedek'),
  'Denetleme Asıl': candidates.filter(c => c.position === 'Denetleme Asıl'),
  'Denetleme Yedek': candidates.filter(c => c.position === 'Denetleme Yedek'),
};

const Candidates: React.FC = () => {
  return (
    <div className="bg-white">
      <div className="bg-odtu-red py-12">
        <div className="container">
          <h1 className="text-3xl md:text-4xl font-bold text-white text-center">Aday Listemiz</h1>
        </div>
      </div>
      
      <div className="container section">
        <div className="max-w-6xl mx-auto">
          <p className="text-lg text-center mb-6">
            ODTÜlüyüzBiz ekibi olarak, ODTÜ İstanbul Mezunları Derneği yönetimine aday olan ekibimizi tanıyın.
            Her bir adayımız, derneğimizi daha ileriye taşımak için farklı alanlarda uzmanlık ve deneyime sahip.
          </p>
          
          <div className="text-center mb-12">
            <Link to="/candidate-bios" className="btn btn-primary">
              Adayların Özgeçmişlerini İnceleyin
            </Link>
          </div>
          
          {/* Pozisyonlara göre gruplandırılmış adaylar */}
          {Object.entries(groupedCandidates).map(([position, positionCandidates]) => (
            <div key={position} className="mb-16">
              <h2 className="text-2xl font-bold text-odtu-red mb-6 pb-2 border-b-2 border-odtu-light-gray">{position}</h2>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {positionCandidates.map((candidate) => (
                  <div key={candidate.id} className="bg-odtu-light-gray rounded-lg overflow-hidden shadow-md flex flex-col">
                    <div className="p-4">
                      <div className="h-64 relative bg-white p-3 border-4 border-odtu-red rounded-lg overflow-hidden">
                        <img 
                          src={candidate.image} 
                          alt={`${candidate.name} - ${candidate.position}`}
                          className="w-full h-full object-contain"
                          onError={(e) => {
                            // Resim yüklenemezse varsayılan bir resim göster
                            (e.target as HTMLImageElement).src = '/images/candidates/default-profile.svg';
                          }}
                        />
                      </div>
                    </div>
                    <div className="p-6 flex-grow">
                      <h2 className="text-2xl md:text-3xl font-bold text-odtu-red mb-2">{candidate.name}</h2>
                      {candidate.department && (
                        <p className="text-base md:text-lg text-gray-700">{candidate.department}</p>
                      )}
                      {candidate.bio && (
                        <p className="mb-4">{candidate.bio}</p>
                      )}
                      {candidate.linkedin && (
                        <a 
                          href={candidate.linkedin} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="inline-flex items-center justify-center px-4 py-2 mt-3 bg-white border-2 border-odtu-red text-odtu-red hover:bg-odtu-red hover:text-white rounded-md transition-colors duration-300 font-medium"
                        >
                          <svg className="h-5 w-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                          </svg>
                          LinkedIn Profili
                        </a>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
          
          <div className="mt-12 text-center">
            <p className="text-lg mb-6">
              16 Mart 2025 tarihinde gerçekleşecek Seçimli Genel Kurul'da desteğinizi bekliyoruz.
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link to="/candidate-bios" className="btn btn-primary">
                Adayların Özgeçmişlerini İnceleyin
              </Link>
              <a 
                href="mailto:info@odtuluyuz.org" 
                className="btn btn-secondary"
              >
                Bizimle İletişime Geçin
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Candidates; 